import _ from 'lodash';
import { RX } from '../../../constants/rx';
import fusionConstant from './FusionConstant';

const { flex } = window;
const { React } = flex.lib;

function FusionLandingPaper(props) {
    const { orgId, code } = flex.getStore().appContext.app;
    const { landing } = flex.getStore();

    const { landingPaperDelay: paperDelay } = fusionConstant;

    const [nextIndex, setNextIndex] = React.useState(0);
    const [papers, setPapers] = React.useState([]);

    var interval;

    React.useEffect(() => {
        flex.trigger(RX.LANDING.GET_IMAGE_URL, orgId, code);
    }, []);

    React.useEffect(() => {
        interval = setInterval(() => {
            setNextIndex((nextIndex + 1) % papers.length);
        }, paperDelay * 1000);
    }, [nextIndex, papers]);

    React.useEffect(() => {
        if (!landing?.imageSrcs) {
            return;
        }

        setPapers(_.toArray(landing.imageSrcs));
    }, [landing]);

    React.useEffect(() => () => clearInterval(interval), [nextIndex, papers]);

    return (
        <div className='fusion-landing__paper'>
            {papers.map((paper, index) => (
                <img src={paper} className={index === nextIndex ? 'active' : 'inactive'} alt='fusion' width='100%' height='100%' key={paper} />
            ))}
        </div>
    );
}

module.exports = FusionLandingPaper;
